import { Navigate, useLocation } from "react-router-dom";
import { routesByRole } from "../config/routes";

const RoleRouteGuard = ({ children }) => {

    const role = localStorage.getItem("currentRole");
    const location = useLocation();

    const allowedRoutes = routesByRole[role] || [];

    const isAllowed = allowedRoutes.some(route => {
        const basePath = route.path.includes("/:")
            ? route.path.split("/:")[0]
            : route.path.replace(/:\w+/g, "").replace(/\/+/g, "/");
        return location.pathname === basePath || location.pathname.startsWith(`${basePath}/`);
    });

    if (!isAllowed) {
        return <Navigate to="*" replace />;
    }

    return children;
};

export default RoleRouteGuard;